export class Config{
    AUTH_URL: string | undefined;
    AUTH_CLIENT_ID: string | undefined;
    ACL_URL: string | undefined;
    SNAPSHOT_URL: string | undefined;
    REQ_URL: string | undefined;
}